import React from 'react';
import { createRoot } from 'react-dom/client';  
import './index.css';
import * as serviceWorker from './serviceWorker';
import Navigation from "./components/Navigation";
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import TagManager from 'react-gtm-module'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  },
});

const tagManagerArgs = {
  gtmId: 'GTM-KKW6ZKT'
}
TagManager.initialize(tagManagerArgs)


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <Navigation />
    </ThemeProvider>
  </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
